/**
 * @file index.tsx
 *
 * @fileoverview Renders a custom HR tag.
 */
import styles from "./Hr.module.scss";

export default function Hr() {
  return <hr className={styles.hr} />;
}
export { Hr };
